import { Pipe, PipeTransform } from '@angular/core';
import {LowerCasePipe} from "@angular/common";
@Pipe({
  name: 'commande'
})
export class CommandePipe implements PipeTransform {

  transform(tabcom: any,mot:any): any {
    console.log(tabcom);
    if(mot){
         tabcom=tabcom.filter(a=>
           a.dateCom.toLowerCase().indexOf(mot.toLowerCase())!=-1 ||
           a.dateLiv.toLowerCase().indexOf(mot.toLowerCase())!=-1 ||
           a.client.tel.toLowerCase().indexOf(mot.toLowerCase())!=-1 ||
           a.numero.toLowerCase().indexOf(mot.toLowerCase())!=-1 ||
           a.client.user.nom.toLowerCase().indexOf(mot.toLowerCase())!=-1||
           a.client.user.prenom.toLowerCase().indexOf(mot.toLowerCase())!=-1
         );
        // console.log(tabcom);

     }

    return tabcom;
  }

}
